import React from "react";
import { AiOutlineClose } from "react-icons/ai";
import Button from "./Button";
import Loader from "./loader";

const Modal = ({
  loading,
  isOpen,
  closeModal,
  imgSrc,
  title,
  modalContent,
  btn1,
  btn2,
  btnClass,
  modalWidth,
  handleBtn2,
  type2,
}) => {
  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      closeModal();
    }
  };

  return (
    <>
      {isOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50"
          onClick={handleOverlayClick}
        >
          <div
            className={`bg-white rounded-[30px] overflow-hidden shadow-lg max-w-2/3 min-w-1/3 p-8 flex flex-col gap-6 ${modalWidth}`}
          >
            <div className="flex justify-between items-center">
              <div className="flex items-center gap-2.5">
                <img src={imgSrc} alt="" />
                <h2 className="text-[26px] font-medium">{title}</h2>
              </div>
              <button
                className="text-gray-600 hover:text-gray-900"
                onClick={closeModal}
              >
                <AiOutlineClose />
              </button>
            </div>

            {modalContent && <div className="my-3">{modalContent}</div>}

            <div className={`flex items-center gap-3 ${btnClass}`}>
              {btn1 && (
                <Button
                  disabled={loading}
                  className={"border w-48 border-green text-green "}
                  children={btn1}
                  onClick={closeModal}
                />
              )}
              {btn2 && (
                <Button
                  icon={loading && <Loader />}
                  disabled={loading}
                  type={type2 ? "submit" : "button"}
                  className={"bg-green text-white w-48"}
                  children={btn2}
                  onClick={handleBtn2}
                />
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Modal;
